if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.PreventResize = false;
    }

    connectedCallback() {
      this.initialize();
      this.bindClose();
    }

    initialize() {
      this.SetResizer();

      const isHidden =
        GetCookie(`HideAnnouncement-${this.GenerateHash()}`) === 'true';

      this.dataset.state = isHidden ? 'inactive' : 'active';

      this.ClearOldAnnouncementCookies();
      this.InitializeSlider();
    }

    bindClose() {
      const closeBtn = this.querySelector('[data-close]');
      if (!closeBtn) return;

      closeBtn.addEventListener('click', () => {
        this.CloseBar();
      });
    }

    GenerateHash() {
      const BlockIds = Array.from(
        this.querySelectorAll('[data-block-id]')
      )
        .map((el) => el.dataset.blockId)
        .join('-');

      let hash = 0;
      for (let i = 0; i < BlockIds.length; i++) {
        hash = ((hash << 5) - hash) + BlockIds.charCodeAt(i);
        hash |= 0;
      }
      return hash;
    }

    ClearOldAnnouncementCookies() {
      document.cookie.split('; ').forEach((cookie) => {
        const name = cookie.split('=')[0];
        if (
          name.includes('HideAnnouncement') &&
          name !== `HideAnnouncement-${this.GenerateHash()}`
        ) {
          DeleteCookie(name);
        }
      });
    }

    InitializeSlider() {
      const sliderEl = this.querySelector('.keen-slider');
      if (!sliderEl) return;

      const cycleDelay =
        parseInt(sliderEl.dataset.cycleDelay, 10) || 3000;

      const slider = new KeenSlider(
        sliderEl,
        { loop: true },
        [
          (slider) => {
            let timeout;

            function clear() {
              clearTimeout(timeout);
            }

            function next() {
              clear();
              if (sliderEl.dataset.autoCycle === 'true') {
                timeout = setTimeout(() => slider.next(), cycleDelay);
              }
            }

            slider.on('created', next);
            slider.on('dragStarted', clear);
            slider.on('animationEnded', next);
            slider.on('updated', next);
          },
        ]
      );

      this.Slider = slider;
    }

    SetMaxHeight() {
      if (this.PreventResize) return;

      this.PreventResize = true;
      this.style.maxHeight = 'unset';

      const height = this.offsetHeight;
      document.documentElement.style.setProperty(
        '--AnnouncementBarHeight',
        this.dataset.state === 'active' ? `${height}px` : '0px'
      );

      this.style.maxHeight = '';
      this.PreventResize = false;
    }

    SetResizer() {
      const observer = new ResizeObserver(() => this.SetMaxHeight());
      observer.observe(this);
    }

    OpenBar() {
      this.dataset.state = 'active';
      this.SetMaxHeight();
    }

    CloseBar() {
      this.dataset.state = 'inactive';

      SetCookie(
        `HideAnnouncement-${this.GenerateHash()}`,
        'true',
        7
      );

      this.PreventResize = true;
      document.documentElement.style.setProperty(
        '--AnnouncementBarHeight',
        '0px'
      );

      setTimeout(() => {
        this.PreventResize = false;
      }, 300);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
